import $ from "cash-dom"

export default class FilterEventsModule {

    static name = 'filterevents'

    constructor(node) {

        this.$filter = $(node)
        this.$list = $(node).next('.foldlist')

        //initial all checkboxes are checked 
        this.activeFilter = Array.from($(node).find('input').map((i, e) => $(e).val()))
        this.availableFilter = Array.from(this.activeFilter)

        this.$filter.on('change', 'input', this.handleCheckbox)
    }

    handleCheckbox = (e) => {

        const val = e.target.value

        //if the single active filter is clicked again, set all
        if(this.activeFilter.length === 1 && this.activeFilter[0] === val) {
            this.activeFilter = this.availableFilter
        //otherwise, set only the clicked
        } else {
            this.activeFilter = [val]
        }

        this.updateDom()
    }
    
    updateDom() {

        //reset
        this.$list.find('.foldable').addClass('hidden')
        this.$filter.find(`input`).prop('checked', false)

        //set checkboxes
        this.activeFilter.forEach((val) => {
            this.$filter
                .find(`input[value="${val}"]`)
                .prop('checked', true)
                //.parents('.filter__select')
                //.addClass('active')
        })
        
        //set list
        const selector = this.activeFilter.map(val => `.foldable[data-attr*="${val}"]`).join(', ')
        const $hits = this.$list.find(selector)
        $hits.removeClass('hidden')
    }
}